import { useEffect, useState } from 'react';
import { data_from_server_post } from '@/shared/http/client';

/**
 * Loads org ``recommended_provider`` once for the commercial model picker badge.
 * Shape: ``{ provider, marked_by, marked_at } | null``.
 */
export function useRecommendedProvider() {
    const [recommendedProvider, setRecommendedProvider] = useState(null);

    useEffect(() => {
        let cancelled = false;
        data_from_server_post(
            'get_organization_settings',
            {},
            (result) => {
                if (cancelled) return;
                setRecommendedProvider(result?.recommended_provider || null);
            },
            () => {
                if (!cancelled) setRecommendedProvider(null);
            }
        );
        return () => {
            cancelled = true;
        };
    }, []);

    return recommendedProvider;
}

export default useRecommendedProvider;
